module.exports = __webpack_public_path__ + "static/media/clock-alert.9f8ab1ce.png";